module.exports = __webpack_public_path__ + "img/9c8b3cf.svg";